import { EUiPropertiesAction, EUiPropertiesSpaceType, EUiPropertiesWidgetType } from "@mm-frontend/clickstream-client-js";
import { EEventType, EPrefixedEventType, TLandingUIProperties } from "./models";

const landingPageSpace = {
  name: 'LANDING_MAIN',
  type: EUiPropertiesSpaceType.PAGE,
};

export const signinUiProperties: TLandingUIProperties = {
  [EEventType.PAGE_VIEW]: {
    space: landingPageSpace,
    action: EUiPropertiesAction.SHOW,
  },
  [EEventType.SIGNIN_BEGIN]: {
    space: landingPageSpace,
    widget: {
      name: 'PERSONAL_ACCOUNT',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.START_BUSINESS]: {
    space: landingPageSpace,
    widget: {
      name: 'BUSINESS_BEGIN',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.AGREEMENT]: {
    space: landingPageSpace,
    widget: {
      name: 'AGREEMENT',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.MANUAL]: {
    space: landingPageSpace,
    widget: {
      name: 'MANUAL',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.REGISTRATION_BEGIN]: {
    space: landingPageSpace,
    section: {
      name: 'BECOME_SELLER',
    },
    widget: {
      name: 'BECOME_SELLER',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EPrefixedEventType.REGISTRATION_BEGIN_FOOTER]: {
    space: landingPageSpace,
    section: {
      name: 'FOOTER',
    },
    widget: {
      name: 'BECOME_SELLER',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.KNOW_MORE]: {
    space: landingPageSpace,
    section: {
      name: 'BECOME_SELLER',
    },
    widget: {
      name: 'KNOW_MORE',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.DP_BEGIN]: {
    space: landingPageSpace,
    section: {
      name: 'OFFER_CARDS',
    },
    group: {
      name: 'DP_OPEN',
    },
    widget: {
      name: 'DETAILS',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EPrefixedEventType.DP_BEGIN_FOOTER]: {
    space: landingPageSpace,
    section: {
      name: 'FOOTER',
    },
    widget: {
      name: 'DP_OPEN',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.OFFER_SERVICES_BEGIN]: {
    space: landingPageSpace,
    section: {
      name: 'OFFER_CARDS',
    },
    group: {
      name: 'OFFER_SERVICES',
    },
    widget: {
      name: 'DETAILS',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
    [EPrefixedEventType.OFFER_SERVICES_BEGIN_FOOTER]: {
    space: landingPageSpace,
    section: {
      name: 'FOOTER',
    },
    widget: {
      name: 'OFFER_SERVICES',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.BECOME_SUPPLIER_BEGIN]: {
    space: landingPageSpace,
    section: {
      name: 'OFFER_CARDS',
    },
    group: {
      name: 'BECOME_SUPPLIER',
    },
    widget: {
      name: 'DETAILS',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EPrefixedEventType.BECOME_SUPPLIER_BEGIN_FOOTER]: {
    space: landingPageSpace,
    section: {
      name: 'FOOTER',
    },
    widget: {
      name: 'BECOME_SUPPLIER',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.HELPER_BOT_BEGIN]: {
    space: landingPageSpace,
    section: {
      name: 'FOOTER',
    },
        widget: {
      name: 'HELPER_BOT_LINK',
      type: EUiPropertiesWidgetType.BUTTON,
    },
    action: EUiPropertiesAction.CLICK,
  },
  [EEventType.SCROLL_ALL]: {
    space: landingPageSpace,
    section: {
      name: 'FOOTER',
    },
    action: EUiPropertiesAction.SCROLL,
  },
};
